import { ENV } from "./envConfig";
// 会员商品code
export const COMPANY_GOOD_CODE = "huabanqiyevip";
export const PERSONAL_GOOD_CODE = "huabangerenvip";
/**
 * 会员下载权益code
 *  */
export const VIP_RIGHT_IDENTIFICATION = "HUABAN_SUCAI";

// 权益包标识 用于权益列表中判断权益类型是什么
// 使用场景：限制24小时加油包权益只能小于10个
export const PERSONAL_UPGRADE = "HUABAN_SUCAI_PERSON_DOWNLOAD"; // 个人升级包权益包标识
export const COMPANY_UPGRADE = "HUABAN_SUCAI_ENTERPRISE_DOWNLOAD"; // 企业升级包权益包标识
export const COMPANY_UPGRADE_PLUS = "HUABAN_SUCAI_ENTERPRISE_DOWNLOAD_2"; // 企业升级包加强版 +40
export const EXTEND_AUTH = "HUABAN_SUCAI_ADVANCED_AUTHORIZAYTION"; // 企业扩展授权
// 大会员下载权益包code
export const BIG_COMPANY_DOWNLOAD_PAKGCODES = [
  "HUABAN_SUCAI_LARGEBUSINESS_DOWNLOAD", //下载+100
];
/**个人无商用授权 */
export const PERSONAL_NO_AUTH = "HUABAN_PERSON_NO_AUTH";

// 24H加油包判断，判断与后端保持一致
const TEM_RIGHT_PACKAGE_CODES = "TEMPORARYDOWNLOAD";
export const isTemRightPackage = (code) => {
  return code.includes(TEM_RIGHT_PACKAGE_CODES);
};
// 扩展授权包
export const AUTH_RIGHT_PACKAGE_CODES = [EXTEND_AUTH];

const prodConf = {
  HBCategoryId: [208, 196, 195, 194, 182, 181, 255, 258, 263, 256].join(","), //HB分类id
  company: {
    vipId: [156, 192],
  },
  personal: {
    vipId: [155, 191],
  },
  personalNoAuth: {
    vipId: [189],
  },
  bigCompany: {
    vipId: [166],
  },
  payUrl: "https://huaban.com",
};

// 稿定类目分类
const VIP_CONF = {
  dev: {
    HBCategoryId: 268, //HB分类id
    company: {
      vipId: [161, 236],
    },
    personal: {
      vipId: [160, 235],
    },
    personalNoAuth: {
      vipId: [234],
    },
    bigCompany: {
      vipId: [171],
    },
    payUrl: "https://dev.huaban.com",
  },
  fat: {
    HBCategoryId: 215, //HB分类id
    company: {
      vipId: [226, 291],
    },
    personal: {
      vipId: [225, 290],
    },
    personalNoAuth: {
      vipId: [292],
    },
    bigCompany: {
      vipId: [245],
    },
    payUrl: "https://fat.huaban.com",
  },
  stage: {
    ...prodConf,
    payUrl: "https://stage.huaban.com",
  },
  prod: prodConf,
};

// ok
export const VIP_CONFIG = VIP_CONF[ENV];

// 一般用于判断商品是什么会员类型
const isCompanyVip = (vipId) => VIP_CONFIG.company.vipId.includes(vipId);
const isPersonalVip = (vipId) => VIP_CONFIG.personal.vipId.includes(vipId);

// ok
export const isPersonalNoAuthVipByVipId = (vipId) =>
  VIP_CONFIG.personalNoAuth.vipId.includes(vipId);
export function getVipTypeById(vipId) {
  if (isPersonalVip(vipId)) return "personal";
  if (isCompanyVip(vipId)) return "company";
  if (isPersonalNoAuthVipByVipId(vipId)) return "personalNoAuth";
  if (VIP_CONFIG.bigCompany.vipId.includes(vipId)) return "bigCompany";
}

// 判断大企业订单，主要用于隐藏订单的继续支付按钮
export function isBigCompanyOrder(order) {
  return (
    order.skus.find((sku) =>
      VIP_CONFIG.bigCompany.vipId.includes(sku?.ref_body?.goods?.vip_id)
    ) || order.skus.find((sku) => (sku?.ref_body.name || "").includes("大企业"))
  );
}

/**
 * 会员等级，用来判断user.extra.material_vip的值对应的会员等级
 *
 * 30:大企业会员 20:企业会员 10:个人会员 8:个人无授权会员 7:单品类会员 5:体验会员
 *
 * -1：会员已过期， 没有值：没有会员
 */
const VIP_LEVEL = {
  /**大企业会员 */
  BIGCOMPANY_VIP: 30,
  /**企业会员 */
  COMPANY_VIP: 20,
  /**个人会员 */
  PERSONAL_VIP: 10,
  /**个人无授权会员 */
  PERSONAL_NO_AUTH_VIP: 8,
  /**单品类会员 */
  SINGLE_VIP: 7,
  /**体验会员 */
  EXPERIENCE_VIP: 5,
};

/** 个人下载VIP与商用VIP的VERSION值 */
export const PERSONAL_VIP_VERSION = {
  AUTH: 0,
  NO_AUTH: 1,
};

const isNotExpire = (user) => user?.extra?.material_vip_expire_at > Date.now();

// 一般用于判断当前用户是什么会员类型
export const isBigCompanyByUser = (user) =>
  user?.extra?.material_vip == VIP_LEVEL.BIGCOMPANY_VIP && isNotExpire(user);
export const isCompanyVipByUser = (user) =>
  user?.extra?.material_vip == VIP_LEVEL.COMPANY_VIP && isNotExpire(user);
export const isPersonalVipByUser = (user) =>
  user?.extra?.material_vip == VIP_LEVEL.PERSONAL_VIP && isNotExpire(user);
export const isExperienceVipByUser = (user) =>
  user?.extra?.material_vip == VIP_LEVEL.EXPERIENCE_VIP && isNotExpire(user);

// ok
export const isSingleVipByUser = (user) => {
  return user?.extra?.material_vip == VIP_LEVEL.SINGLE_VIP && isNotExpire(user);
};
// ok
export const isPersonalNoAuthVipByUser = (user) => {
  return (
    user?.extra?.material_vip == VIP_LEVEL.PERSONAL_NO_AUTH_VIP &&
    isNotExpire(user)
  );
};

export const isNoAuthByUser = (user) => {
  return user?.extra?.material_vip_auth == 0;
};

export function getVipTypeByUser(user) {
  if (user?.extra?.material_vip && isNotExpire(user)) {
    switch (user.extra.material_vip) {
      case VIP_LEVEL.EXPERIENCE_VIP:
        // 体验会员
        return "experience";
      case VIP_LEVEL.SINGLE_VIP:
        // 单品类无商用授权会员
        if (user.extra?.material_vip_auth === 0) {
          return "singleNoAuth";
        }
        // 单品类会员
        return "single";
      case VIP_LEVEL.PERSONAL_NO_AUTH_VIP:
        return "personalNoAuth";
      case VIP_LEVEL.PERSONAL_VIP:
        // 个人会员
        return "personal";
      case VIP_LEVEL.COMPANY_VIP:
        // 企业会员
        return "company";
      case VIP_LEVEL.BIGCOMPANY_VIP:
        // 大企业会员
        return "bigCompany";
      default:
        return "no";
    }
  }
  return "no";
}

/**黑底白字会员标识 */
export const vipTag = {
  company: "https://st0.dancf.com/static/02/202311220706-8a04.svg",
  personal: "https://st0.dancf.com/static/02/202403051047-876c.svg",
  experience: "https://st0.dancf.com/static/02/202205100357-0dfb.svg",
  no: "https://st0.dancf.com/static/02/202205100328-b1ee.svg",
  bigCompany: "https://st0.dancf.com/static/02/202208020156-ff59.svg",
  singleNoAuth: "https://st0.dancf.com/static/02/202311220706-0ab2.svg",
  single: "https://st0.dancf.com/static/02/202311280242-92ce.svg",
  personalNoAuth: "https://st0.dancf.com/static/02/202403010442-dbef.svg",
};

export const VipTitleMap = {
  single: "商用模板VIP",
  company: "企业全站VIP",
  personal: "个人商用VIP",
  experience: "体验VIP",
  no: "",
  bigCompany: "大企业VIP",
  singleNoAuth: "模板VIP",
  personalNoAuth: "个人下载VIP",
};

/**
 *
 * @param {IUser} user
 * @returns {"企业VIP" | "个人VIP" | "体验VIP" | "" | "大企业VIP}
 */
export function getVipTitleByUser(user) {
  const vipType = getVipTypeByUser(user);
  return VipTitleMap[vipType];
}

/**
 *
 * @param {IUser} user
 * @returns
 */
export function isVipByUser(user) {
  return user?.extra?.material_vip > 0 && isNotExpire(user);
}

/**
 * 个人类型会员：个人商用、个人无商用、单品类、体验会员
 */
export function isPersonalType(user) {
  return (
    user?.extra?.material_vip > 0 &&
    user?.extra?.material_vip <= VIP_LEVEL.PERSONAL_VIP &&
    isNotExpire(user)
  );
}
/**
 * 企业类型会员：企业、大企业
 */
export function isCompanyType(user) {
  return (
    user?.extra?.material_vip > VIP_LEVEL.PERSONAL_VIP && isNotExpire(user)
  );
}
